import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../services/auth.service';

interface UsePasswordChangeHandlerReturn {
  /** Maneja errores de API y determina si redirigir al cambio de contraseña */
  handleApiError: (error: any) => boolean;
}

/**
 * Hook personalizado para manejar el flujo de cambio de contraseña requerido
 * 
 * @returns Objeto con funciones para manejar el cambio de contraseña requerido
 */
export const usePasswordChangeHandler = (): UsePasswordChangeHandlerReturn => {
  const navigate = useNavigate();

  /**
   * Maneja errores de API y determina si se debe redirigir al cambio de contraseña
   * 
   * @param error - Error de la respuesta de la API
   * @returns true si se manejó el error (PASSWORD_CHANGE_REQUIRED), false en caso contrario
   */
  const handleApiError = useCallback((error: any): boolean => {
    if (AuthService.isPasswordChangeRequired(error)) {
      navigate('/auth/change-password');
      return true;
    }
    return false;
  }, [navigate]);

  return {
    handleApiError,
  };
};
